import { httpClient } from "../../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../../utils/ApiEndpoint";

export const fetchWebserviceSummary = async ({ data, token }) => {
  const response = await httpClient(
    "POST",
    `${ApiEndpoint}/adminreports/webservicesummary`,
    data,
    token,
  );
  return response.data;
};

export const fetchPartners = async ({ token }) => {
  const response = await httpClient("GET", ApiEndpoint + `partners`, {}, token);

  return response.data;
};
